import request from '@/utils/request'

export const categoryApi = {
  // 获取商品分类树
  getTree() {
    return request({
      url: '/inventory-management-api/common/category/tree',
      method: 'POST',
      data: {
        type: 'product'
      }
    })
  },

  // 批量编辑商品分类
  batchUpdate(data) {
    return request({
      url: '/inventory-management-api/common/category/batchUpdate',
      method: 'POST',
      data
    })
  },

  // 删除分类
  delete(id) {
    return request({
      url: '/inventory-management-api/common/category/delete',
      method: 'POST',
      data: { id }
    })
  }
}